/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_qr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is my data uploaded anywhere?`)
};

const es_qr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Se sube mi contenido a algún sitio?`)
};

const de_qr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werden meine Daten irgendwohin hochgeladen?`)
};

const nl_qr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worden mijn gegevens ergens geüpload?`)
};

const fr_qr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes données sont-elles envoyées quelque part ?`)
};

const it_qr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I miei dati vengono caricati da qualche parte?`)
};

const pt_br2_qr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meus dados são enviados para algum lugar?`)
};

const pt_qr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os meus dados são enviados para algum lado?`)
};

const ja_qr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データはどこかにアップロードされますか?`)
};

const zh_qr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的数据会被上传到哪里吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const qr_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.qr_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("qr_faq_q3", locale)
	if (locale === "en") return en_qr_faq_q3(inputs)
	if (locale === "es") return es_qr_faq_q3(inputs)
	if (locale === "de") return de_qr_faq_q3(inputs)
	if (locale === "nl") return nl_qr_faq_q3(inputs)
	if (locale === "fr") return fr_qr_faq_q3(inputs)
	if (locale === "it") return it_qr_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_qr_faq_q3(inputs)
	if (locale === "pt") return pt_qr_faq_q3(inputs)
	if (locale === "ja") return ja_qr_faq_q3(inputs)
	return zh_qr_faq_q3(inputs)
};